$(function() {
    let $social = $('.js-social-block'),
        headerHeight = $('.page-header').outerHeight(),
        socialOffset = $social.length ? $social.offset().top - headerHeight : '',
        offsetTop = headerHeight,
        contentHeight = $('.js-content-container').innerHeight();

    if ($social && window.innerWidth > 992) {
        $(window).on('scroll', function H() {
            if($(window).scrollTop() >= socialOffset) {
                $social.css({
                    position: 'fixed',
                    top: `${offsetTop}px`,
                    bottom: 'auto'
                });

                if ($(window).scrollTop() >= socialOffset + contentHeight - $social.height()) {
                    $social.css({
                        position: 'absolute',
                        top: 'auto',
                        bottom: 0
                    });
                }

            } else {
                $social.css({
                    position: 'static'
                });
            }
        });
    }
});